import { z } from 'zod';

import {
  differentialDiagnosesDisplaySchema,
  differentialDiagnosesSchema,
} from './differential-diagnoses';

export const redFlagSchema = z.object({
  callout: z.string(),
  context: z.string(),
});

export const redFlagsSchema = z.array(redFlagSchema);

export const redFlagsOutputSchema = z.object({
  differential_diagnoses: differentialDiagnosesSchema,
  red_flags: redFlagsSchema,
});

// Lenient variant for rendering stored outputs (see differential-diagnoses.ts)
export const redFlagsOutputDisplaySchema = z.object({
  differential_diagnoses: differentialDiagnosesDisplaySchema.catch([]),
  red_flags: redFlagsSchema.catch([]),
});

export type RedFlagsOutputSchema = z.infer<typeof redFlagsOutputSchema>;
export type RedFlagsOutputDisplaySchema = z.infer<
  typeof redFlagsOutputDisplaySchema
>;
